import { Component, OnInit, Input } from '@angular/core';
//import { Flower } from '../flower'
import { PageService } from '../page.service'
import { DbRecord } from '../db-record'

@Component({
  selector: 'app-pages-box',
  templateUrl: './pages-box.component.html',
  styleUrls: ['./pages-box.component.css']
})
export class PagesBoxComponent implements OnInit {
  @Input() dbRecords: DbRecord[]
  @Input() showNoHit = false

  constructor(private pgs: PageService) { }

  ngOnInit() { }

  get startPageRecords() {
    let lsLen
    let pgLen
    this.pgs.recordsLength = this.dbRecords.length
    lsLen = this.pgs.recordsLength
    pgLen = this.pgs.pageLength

    let ls = []

    for (let i = 0; i < lsLen; i += pgLen)
      ls.push(i)
    return ls
  }

  get hasHits() {
    return !!this.dbRecords.length
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/pages-box/pages-box.component.ts